<template>
  <job-item-content v-bind="$attrs" v-on="$listeners" @search="searchJob" />
</template>

<script lang="ts">
import { Component } from 'vue-property-decorator';
import { ProfessionModule } from '@/store/modules/profession';
import { mixins } from 'vue-class-component';
import GoogleTranslate from '@/mixins/GoogleTranslate';
import JobItemContent from '@/components/Home/JobItemContent.vue';
import { CompanyModule } from '@/store/modules/company';

@Component({
  components: { JobItemContent },
})
export default class JobItemCluster extends mixins(GoogleTranslate) {
  searchJob(data: { id: number, firmName: string, shortview: string, companyId: number }) {
    ProfessionModule.SetJobId(data.id);
    ProfessionModule.SetJobFirm(data.firmName);
    ProfessionModule.SetJobShort(data.shortview);
    CompanyModule.RESET_COMPANY_DETAIL_FILTER();
    CompanyModule.SetCompanyDetailFilter({ obj: 'idcomp', value: data.companyId });
    // ClustersModule.SetUrlIframe(this.url);
  }
}
</script>
